<template>
    <div class="analysis-details"> 
        <div class="details-info">  
            <div class="info-association">
                <div style="width:900px;height:600px;position: relative;" id="d3DIV" class="association-d3">  
                    <!-- style="position:absolute;top:50%;left:50%;transform: translate(-50%, -50%); " :style="{'width':this.width+'px','height':this.height+'px'}" -->
                    <div   ref='d3Info' id="d3Info"> </div> 
                </div>
                <el-table
                    :data='tableList'
                    @sort-change="sort_change"
                    :header-cell-style="{background:'#409EFF',color:'#fff'}"
                    size='mini'
                    row-key="id"
                    border 
                    default-expand-all>
                    <el-table-column
                        sortable
                        label="NO"
                        align="center"
                        prop="num"
                    >
                    </el-table-column>
                    <el-table-column
                        sortable
                        align="center"
                        prop="name"
                        label="样本名称">
                    </el-table-column>
                    <el-table-column
                        sortable
                        align="center"
                        prop="group"
                        label="Cluster ID">
                    </el-table-column>
                </el-table>
                <el-pagination 
                    size='small'
                    class="page-wrap"  
                    @current-change="changePage" 
                    @size-change="sizeChange"
                    background
                    :current-page="pageInfo.pageNum" 
                    :page-count="pageInfo.pageTotal" 
                    :page-size="pageInfo.pageSize"
                    :page-sizes="[10, 20, 30, 50, 100]"
                    :total="pageInfo.total"
                    layout="total, sizes, prev, pager, next, jumper" >
                </el-pagination>
            </div> 

        </div>
    </div>
</template>

<script> 
import domToImage from 'dom-to-image';  
import {ForceGraph} from './forceGraph.js' 
import * as d3 from 'd3' 
import subjectData from './subjectData.js'
export default {
    props: ['dataList'],
    components: { 
    },
    data () {
        return {
            isLoad:false,
            beforeValue:this.$route.query.beforeValue,
            afterValue:this.$route.query.afterValue,
            tableList:[],
            tableListAll:[],
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            },
            isShowReport:false,
            reportName:'',
            optionLable:this.$route.query.optionLable||'',
            lineLength:2,
            // dataList:subjectData.associationList,
            width: 1160,
            height: 740,
            //生成报告
            reportImg:'', 
            reportList:[],
            clusterID:[],
            clusterVal:[],//选择的clusterId
            nodesArr:[],
            edgesArr:[],

        }
    },
    mounted () {
        // this.initGraph();
        this.getInfo() 
    },
    methods: {
         getInfo(){
            let attNa= `${this.beforeValue}—${this.afterValue}`;
            let param={
                attNa,
                attrNames:this.optionLable,//
            } 
            this.nodesArr=this.dataList.nodes;
            this.edgesArr=this.dataList.edges
            this.initGraph();
            this.tableListAll = [].concat(this.dataList.nodes);
            this.clusterID=[];

            console.log(this.tableListAll,'==tall')
            this.tableListAll&&this.tableListAll.forEach((item,index)=>{
                item.num=index+1;
                this.clusterID.push(Number(item.group));
                let obj = {
                    keyName:item.id,
                    valueName:item.name,
                    group:item.group,
                }
                //生成报告用的list字段需要重新定义，
                this.reportList.push(obj)
            })  
            this.clusterID=[...new Set(this.clusterID)].sort();
            this.clusterVal=this.clusterID;
            this.pageInfo.total = this.tableListAll.length;
            this.changePage(1);



            // analysis_st(param).then(res=>{
            //     let data = res.data;
            //     if(data&&data.code==0){
            //         this.dataList= data.data.defGraph 
            //         this.nodesArr=this.dataList.nodes;
            //         this.edgesArr=this.dataList.edges
            //         this.initGraph();
            //         this.tableListAll = [].concat(this.dataList.nodes);
            //         this.clusterID=[];
            //         this.tableListAll&&this.tableListAll.forEach((item,index)=>{
            //             item.num=index+1;
            //             this.clusterID.push(Number(item.group));
            //             let obj = {
            //                 keyName:item.id,
            //                 valueName:item.name,
            //                 group:item.group,
            //             }
            //             //生成报告用的list字段需要重新定义，
            //             this.reportList.push(obj)
            //         })  
            //         this.clusterID=[...new Set(this.clusterID)].sort();
            //         this.clusterVal=this.clusterID;
            //         this.pageInfo.total = this.tableListAll.length;
            //         this.changePage(1);

            //     }else{
            //         this.$message.error(data.msg||'请求失败～')
            //     }
            //     this.isLoad = false;
            // })
        },
        clusterChange(value){ 
            this.clusterVal= value; 
            this.nodesArr =[] 
            this.nodesArr = [...this.dataList.nodes].filter(x => [...this.clusterVal].some(y => y == x.group));
            let nodesArrMap = this.nodesArr.map(item => item.id);
             this.edgesArr=[];
            this.edgesArr = this.dataList.edges.filter(item => (nodesArrMap.includes(item.source)&&nodesArrMap.includes(item.target)))

            this.initGraph();
 
            // this.dataList.nodes
        },
        uniqueFunc(arr, uniId){
            const res = new Map();
            return arr.filter((item) => !res.has(item[uniId]) && res.set(item[uniId], 1));
        },
        initGraph(){
            this.$refs.d3Info.innerHTML = ""
			let params={
				nodeId: d => d.id,
                nodeGroup: d => d.group,
                nodeTitle: d => d.id,
                linkStrokeWidth: l => 2,
				// nodeStrength:'1700px',
				nodeRadius:10,//节点半径
                width:this.width,
                height: this.height,
				lineLength:this.lineLength
			}
            // this.dataList=dataJson
            let initData={
                // nodes:this.dataList.nodes||[],
                // links:this.dataList.edges||[],
                nodes:this.nodesArr||[],
                links:this.edgesArr||[],
            };   
			let force_graph=ForceGraph(initData, params)
			this.$refs.d3Info.append(force_graph);
        }, 
        sliderChange(val){
            this.lineLength=val; 
            this.width=1160*(val>2?val/2.4:1);
            this.height=740*(val>2?val/2.4:1);
            this.initGraph()
        },
       
        save_pic(){
            // let svgElement = d3.select("svg").node(); 
            let svgElement = document.getElementById('d3Info'); 
            // 使用dom-to-image库将SVG转为图像 scale提高图片分辨率 （README.md里有修改步骤）
            domToImage.toPng(svgElement,{scale:2}) .then((dataUrl) => {
                const downloadLink = document.createElement('a');
                downloadLink.href = dataUrl;
                downloadLink.download = `${this.beforeValue}—${this.afterValue}-社团分析结果图.png`;
                downloadLink.click();
            })
            .catch((error) => {
                console.error('Error converting SVG to image:', error);
            }); 
        },
       
        report(){
            // this.isShowReport = true;
            let  svgElement = document.getElementById('d3Info');
            let _this = this
            domToImage.toPng(svgElement,{scale:2}).then(function (dataUrl) {
 
                _this.reportImg = dataUrl;
                _this.isShowReport = true;
            }).catch(function (error) {
                console.error('生成失败', error);
                _this.$message.error('生成图片失败～');
            });
        },
        report_sure(){
            
        },
        go_back(){
            this.$router.push({
                path:'excavate',
                query:{
                    navType:4,
                }
            }) 
        },
        analysis(){
            if(this.distanceValue==''||this.clusterVal==''){
                this.$message.error('请选择距离类型或聚类方法～')
                return
            }
        },
         /*
            列表及分页table排序======================
        */ 
        changePage(num) { 
            this.pageInfo.pageNum = num;
            this.tableList= this.tableListAll.slice((this.pageInfo.pageNum-1)*this.pageInfo.pageSize,this.pageInfo.pageNum*this.pageInfo.pageSize);
        }, 
        sort_change(column) { // column是个形参，具体查看element-ui文档
            this.column = column; 
            this.tableList = this.tableListAll.sort(this.sortFun(column.prop, column.order === 'ascending'));
            // 回到第一页
            this.changePage(1);

        },
        sortFun (attr, rev) {
            //第一个参数传入info里的prop表示排的是哪一列，第二个参数是升还是降排序
            if (rev == undefined) {
                rev = 1;
            } else {
                rev = (rev) ? 1 : -1;
            }
            return function (a, b) {
                a = a[attr];
                b = b[attr];
                if (a < b) {
                    return rev * -1;
                }
                if (a > b) {
                    return rev * 1;
                }
                return 0;
            }
        },
        sizeChange(val){
            this.pageInfo.pageTotal=Math.ceil(this.pageInfo.total/val),
            this.pageInfo.pageSize=val; 
            this.changePage(1)
        },
    }
}
</script>

<style lang="less" scoped>
    @import url('../../css/excavate/analysis_details.less');
    .info-cluster{
        display: flex;
        .label{
            margin-right: 20px;
            font-weight: bold;
            span{
                color: red;
            }
        }
    }
</style>